import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Service {
	id: number;
	service_name: string;
	slug: string;
	tagline?: string;
	short_description?: string;
	pricing: number;
	duration_minutes?: number;
	image_path?: string;
}

export interface ServiceCategory {
	id: number;
	name: string;
	slug: string;
	description: string;
	icon: string;
	image?: string;
	display_order: number;
	is_active: boolean;
	services_count?: number;
	services?: Service[];
	created_at: string;
	updated_at: string;
}

export interface ApiResponse<T> {
	status: boolean;
	data: T;
	message?: string;
}

@Injectable({
	providedIn: 'root',
})
export class ServiceCategoryService {
	private http = inject(HttpClient);
	private apiUrl = environment.apiUrl;

	// Admin APIs
	getAll(): Observable<ApiResponse<ServiceCategory[]>> {
		return this.http.get<ApiResponse<ServiceCategory[]>>(`${this.apiUrl}/admin/service-categories`);
	}

	getById(id: number): Observable<ApiResponse<ServiceCategory>> {
		return this.http.get<ApiResponse<ServiceCategory>>(`${this.apiUrl}/admin/service-categories/${id}`);
	}

	create(data: FormData): Observable<ApiResponse<ServiceCategory>> {
		return this.http.post<ApiResponse<ServiceCategory>>(`${this.apiUrl}/admin/service-categories`, data);
	}

	update(id: number, data: FormData): Observable<ApiResponse<ServiceCategory>> {
		return this.http.post<ApiResponse<ServiceCategory>>(`${this.apiUrl}/admin/service-categories/${id}`, data);
	}

	delete(id: number): Observable<ApiResponse<null>> {
		return this.http.delete<ApiResponse<null>>(`${this.apiUrl}/admin/service-categories/${id}`);
	}

	// Public API
	getActive(): Observable<ApiResponse<ServiceCategory[]>> {
		return this.http.get<ApiResponse<ServiceCategory[]>>(`${this.apiUrl}/public/service-categories`);
	}
}
